import { HeroBannerV1, heroBannerConfigV1, HeroBannerV2, heroBannerConfigV2 } from './hero-banner';
import Button, { buttonConfig } from './button';
import Card, { cardConfig } from './card';
import Carousel, { carouselConfig } from './carousel';
import Columns, { columnsConfig } from './columns';
import FAQSectionRef, { faqSectionRefConfig } from './faq-section-ref';
import HubspotForm, { hubspotFormConfig } from './hubspot-form';
import Modal, { modalConfig } from './modal';
import QuoteCard, { quoteCardConfig } from './quote-card';
import ROICalcualtor, {roiCalculatorConfig} from './roi-calculator';
import Section, { sectionConfig } from './section';
import StaggeredCard, { staggeredCardConfig } from './staggered-card';
import Text, { textConfig } from './text';
import Wistia, {wistiaConfig} from './wistia';
import WistiaModal, {wistiaModalConfig} from './wistia-modal';
import Video, { videoConfig } from './video';

// These are selected so we can decrease our bundle size.
import '@builder.io/react/dist/lib/src/blocks/Columns'
import '@builder.io/react/dist/lib/src/blocks/CustomCode'
import '@builder.io/react/dist/lib/src/blocks/Embed'
import '@builder.io/react/dist/lib/src/blocks/Fragment'
import '@builder.io/react/dist/lib/src/blocks/Image'
import '@builder.io/react/dist/lib/src/blocks/Section'
import '@builder.io/react/dist/lib/src/blocks/Slot'
import '@builder.io/react/dist/lib/src/blocks/Symbol'
import '@builder.io/react/dist/lib/src/blocks/Text'
/**
 * Helper to register all builder components.
 * If you'd like a subset, or to register them differently,
 * you should registerComponents in a different place and not
 * use this function.
 */
export default function registerComponents(Builder, components) {
  Builder.registerComponent(Button, buttonConfig);
  Builder.registerComponent(Card, cardConfig);
  Builder.registerComponent(Carousel, carouselConfig);
  Builder.registerComponent(Columns, columnsConfig);
  Builder.registerComponent(FAQSectionRef, faqSectionRefConfig);
  Builder.registerComponent(HeroBannerV1, heroBannerConfigV1);
  Builder.registerComponent(HeroBannerV2, heroBannerConfigV2);
  Builder.registerComponent(HubspotForm, hubspotFormConfig);
  Builder.registerComponent(Modal, modalConfig);
  Builder.registerComponent(QuoteCard, quoteCardConfig);
  Builder.registerComponent(ROICalcualtor, roiCalculatorConfig);
  Builder.registerComponent(Section, sectionConfig);
  Builder.registerComponent(StaggeredCard, staggeredCardConfig);
  Builder.registerComponent(Text, textConfig);
  Builder.registerComponent(Video, videoConfig);
  Builder.registerComponent(Wistia, wistiaConfig);
  Builder.registerComponent(WistiaModal, wistiaModalConfig);

  components?.forEach(({config, component}) => Builder.registerComponent(component, config));

  const componentNames = components?.map(({ config }) => ({ name: config.name})) ?? [];

  Builder.register('insertMenu', {
    name: 'Glowforge Components',
    items: [
      { name: buttonConfig.name },
      { name: cardConfig.name },
      { name: carouselConfig.name },
      { name: columnsConfig.name },
      { name: faqSectionRefConfig.name },
      { name: heroBannerConfigV2.friendlyName },
      { name: hubspotFormConfig.name },
      { name: modalConfig.name },
      { name: quoteCardConfig.name },
      { name: sectionConfig.name },
      { name: staggeredCardConfig.name },
      { name: textConfig.name },
      { name: wistiaConfig.name},
      { name: wistiaModalConfig.name},
      { name: roiCalculatorConfig.name},
      { name: videoConfig.name},
      ...componentNames,
    ],
  });

  Builder.register('insertMenu', {
    name: 'Builder Components',
    items: [
      { name: 'Image' },
      {
        name: 'Box',
        item: {
          '@type': '@builder.io/sdk:Element',
        },
      },
      { name: 'Custom Code' },
      { name: 'Embed' },
      { name: 'Slot' },
    ],
  });
}
